export const environment = {
    cfgApiBaseUrl: 'http://localhost/red-api',
    appBaseRef: 'http://localhost:4200'
};